module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Chapter "), _c('span', {
    staticClass: "CN_BOLD"
  }, [_vm._v("Th")]), _c('span', {
    staticClass: "CN_BOLD"
  }, [_vm._v("r")]), _c('span', {
    staticClass: "CN_BOLD"
  }, [_vm._v("ee")])])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "CIT"
  }, [_c('span', {
    staticClass: "FIRSTLINE_CIT"
  }, [_vm._v("THAT NIGHT VICTOR, MY STEPDAD,")]), _vm._v(" makes lasagna for dinner. After Mom’s death he’s gone way above in the parent department. He’s home by six, and family dinner is every night at seven.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Dinner we’re "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("all")]), _vm._v(" expected to be at. Dinner everyone seems to need but me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Dr. Depof suggested I make a new friend,” Justin, my younger brother, is saying. “And so I said hi to Christopher today and I’ve never done that before.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“How did that make you feel?” Victor parrots Dr. Depof, our family grief counselor.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It made me feel really good about myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("It makes me feel like I want to stab myself in the eye.")])])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("Victor turns to Daisy. “How’d you do on your history exam?”")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("She brightens. “A lot better than I thought.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Good, Daisy!” he verbally applauds.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They all smile at each other, and I swallow the overwhelming desire to scream.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Now is the point in dinner where everyone gets contemplative and silent as they eat lasagna and pretend they’re "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("healing")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Ugh.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("But first Victor turns to me, the rock. “Lane, all good today? Anything to report?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Fine,” I reply as he expects.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You going out again tonight?” he asks.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yes.” I’m going after Jacks again. And this time I "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("will")]), _vm._v(" get him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Maybe you should try staying in. . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I look him in the eyes, and way in their depths I catch a glimpse of the stepdad he used to be before all this went down. Strong. Kind. Loving. Solid. Does this whole "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("healing")]), _vm._v(" thing wear him out as much as it does me? Is he tired of being selfless, forcing optimism, and hiding his real grief for our sake?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Okay,” I reluctantly agree. “I’ll stay in.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I swear I hear a sigh of relief. That, coupled with Daisy’s and Justin’s dual smiles, gives me a pang of guilt for being gone so much.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("I volunteer to do dishes, as I often do. I have a theory that the more steadfast I am around the house—the more chores I do—the more freedom I receive. So far it’s a theory that works.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("Victor goes into what used to be my mom’s office, and my brother and sister disappear upstairs. I turn on the news and run a sink of soapy water.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“The Masked Savior has gone too far,” a reporter is saying.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I perk up. The Masked Savior is what the news stupidly dubbed me back when I completed my first vigilante act—the Weasel, the rapist.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("They flash a website up on the screen. I look at the Masked Savior URL. What the hell? I have my own site?")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Alleged drug dealer John Jacks Jones was found beaten to near death in an alley off MLK. He was—”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Wait a minute. "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("What?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("That’s the same alley I’d been in last night when I swore someone was following me. But he was fine when I left, when I couldn’t go through with things.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The reporter goes on to describe the messy bludgeoning details. Tasered first. Zip-tied. Beaten with a baseball bat. Left in the alley. Found by some homeless guy.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I would never have done it that way.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Witnesses said they saw a person dressed in all black and wearing a mask. . . .” The reporter goes on to detail how Jacks was allegedly a member of a local gang.")])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("Allege. Alleged. Allegedly.")]), _vm._v(" I hate all forms of that word. That’s a cover-your-ass word. They flash a picture of Jacks on to the screen, and I think of last night and how I froze up.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("The reporter transitions to another story, and I dry my hands and go get my laptop. I bring up my very own URL and holy damn, sure enough, the Masked Savior has a site.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("And apparently quite a following. Not only are there details on the acts I actually did before Mom—the rapist, the drunk driver, the animal abuser, the human trafficker—but there are several more I’m getting credit for that I didn’t do. Like Jacks.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This isn’t good. This "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("so")]), _vm._v(" isn’t good.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I click into the forum and read some of the posts.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("[j_d_l] The M. Savior should’ve overdosed JJJ like he did those kids.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("[KellyKat] What’s up with shaving that girl’s head?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("[HellsBells] Hey, homies, I’m new. What up?")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I continue reading through the multitude of comments as everyone discusses the various vigilante acts. People like what I’m doing enough to have dedicated a whole site to me. While that makes me feel honored and justified, it also concerns me. I don’t want or need a fan club. I can’t afford to have people doing stuff “in my name.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Anonymity is essential. It’s what I need. What I want. The time and space to be me.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("The time and space to be me . . .")])])]), _c('p', {
    staticClass: "TX"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("My gaze trails back to the comment about Jacks. I need to figure out who did this to him—who impersonated me, "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("copycatted")]), _vm._v(" me, and beat him to near death. He has a partner, Aisha. Was "), _c('span', {
    staticClass: "TX-ITAL"
  }, [_vm._v("she")]), _vm._v(" the one I felt watching? Did something go wrong between them and did they have a fight?")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "TX"
  }, [_vm._v("I plug my flash drive in and bring up Aisha’s picture and the information I already have on her. When I first saw her in Penn’s court, she was very pretty with her dark ponytail and perfect makeup. I remember thinking how she looked more like a model than a drug dealer.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Then again, I don’t look like who I am either.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I zoom in on her picture and her dark brown eyes, and I study them. Sure she’s smiling, but there’s something just not there. The smile is on her lips, but definitely not in her eyes. Those eyes . . . there’s something empty in them.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Victor comes back out of the office and I glance up.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m going to be clearing out Mom’s locker at work,” he tells me. “I’ll bring her personal things home so you and Daisy can go through them. See if there’s anything you want.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I nod, though my brain immediately starts spinning. A locker at work. Personal things. Surely, Mom wouldn’t have kept anything questionable at the FBI, would she?")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9479aaa4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch03.vue
// module id = 69
// module chunks = 0